import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';

const RegistrationPending = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet><title>Approval Pending - SugarHathi</title></Helmet>
      <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#f8f1e9' }}>
        <div className="bg-white rounded-2xl shadow-lg border border-amber-100 p-10 max-w-md w-full text-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5" style={{ backgroundColor: '#fef3c7' }}>
            <Icon name="Clock" size={36} color="#f59e0b" />
          </div>
          <h2 className="text-xl font-bold mb-2" style={{ color: '#1e4a72' }}>Approval Pending</h2>
          <p className="text-sm mb-6" style={{ color: '#6b7280' }}>
            Your registration request is under review. You will be able to log in once an admin approves your account.
          </p>
          <button
            onClick={() => navigate('/login-authentication')}
            className="w-full py-3 rounded-xl font-semibold text-sm text-white transition hover:opacity-90"
            style={{ backgroundColor: '#f59e0b' }}
          >
            Back to Login
          </button>
        </div>
      </div>
    </>
  );
};

export default RegistrationPending;
